import { ArrowLeftIcon } from '@phosphor-icons/react';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';

import { ICON_WEIGHT } from '@/components/icon';
import { AircraftForm } from '@/features/aircraft';

function NewAircraftPage() {
  const navigate = useNavigate();
  const { registration } = Route.useSearch();

  return (
    <div className="mx-auto w-full max-w-xl space-y-4">
      <Link
        to="/aircraft"
        className="text-muted-foreground hover:text-foreground inline-flex items-center gap-1.5 text-sm"
      >
        <ArrowLeftIcon aria-hidden="true" weight={ICON_WEIGHT} className="size-4" />
        Aircraft
      </Link>
      <h1 className="text-lg font-semibold tracking-tight">Add aircraft</h1>
      <AircraftForm
        {...(registration === undefined ? {} : { initialRegistration: registration })}
        onSaved={() => {
          void navigate({ to: '/aircraft' });
        }}
        onCancel={() => {
          void navigate({ to: '/aircraft' });
        }}
      />
    </div>
  );
}

export const Route = createFileRoute('/aircraft/new')({
  // A flight detail page can send its own track's registration through here
  // — see `flights.$trackId.tsx` — so adding the aircraft it belongs to
  // doesn't mean retyping what the track already knows.
  validateSearch: (search: Record<string, unknown>): { registration?: string } =>
    typeof search.registration === 'string' ? { registration: search.registration } : {},
  component: NewAircraftPage,
});
